import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'submit'];

  connect() {
    this.checkFields();

    this.fieldTargets.forEach((field) => {
      field.addEventListener('input', () => this.checkFields());
    });

    this.element.addEventListener('submit', (event) =>
      this.handleSubmit(event)
    );
  }

  checkFields() {
    const allFilled = this.fieldTargets.every(
      (field) => field.value && field.value.trim() !== ''
    );
    this.submitTarget.disabled = !allFilled;
    this.submitTarget.style.opacity = allFilled ? '1' : '0';
  }

  handleSubmit(event) {
    this.submitTarget.disabled = true;
    document.body.style.cursor = 'wait';
  }
}
